module.exports = __webpack_public_path__ + "static/img/Frame_4266@2x.6565a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4266@2x.png
// module id = 5knX
// module chunks = 55